import { type TrendsCopy } from '../../core'

export const buildEmptyStateProps = (
  copy: TrendsCopy,
  hasAggregation: boolean,
  handler: () => void,
) => ({
  description: hasAggregation
    ? copy.empty_state_sub_text
    : copy.empty_state_sub_text_no_aggregation,
  header: hasAggregation
    ? copy.zero_state_content_header
    : copy.zero_state_content_header_no_aggregation,
  onClickHandler: hasAggregation ? handler : undefined,
  primaryButton: hasAggregation ? copy.empty_state_primary : undefined,
})
